var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      directives: [
        {
          name: "clickoutside",
          rawName: "v-clickoutside",
          value: _vm.handleClickoutside,
          expression: "handleClickoutside"
        }
      ],
      ref: "reference",
      staticClass: "multi-el-cascader multi-cascader",
      class: [
        {
          "is-opened": _vm.menuVisible,
          "is-disabled": _vm.cascaderDisabled
        },
        _vm.cascaderSize ? "multi-el-cascader--" + _vm.cascaderSize : ""
      ],
      on: {
        click: _vm.handleClick,
        mouseenter: function($event) {
          _vm.inputHover = true
        },
        focus: function($event) {
          _vm.inputHover = true
        },
        mouseleave: function($event) {
          _vm.inputHover = false
        },
        blur: function($event) {
          _vm.inputHover = false
        },
        keydown: _vm.handleKeydown
      }
    },
    [
      _c(
        "el-input",
        {
          ref: "input",
          staticClass: "multi-base-input",
          class: {
            "is-focus": _vm.menuVisible,
            "multi-el-multicascader__search":
              _vm.filterable && !_vm.currentLabels.length
          },
          attrs: {
            readonly: _vm.readonly,
            placeholder: _vm.currentLabels.length ? undefined : _vm.placeholder,
            "validate-event": false,
            size: _vm.size,
            disabled: _vm.cascaderDisabled
          },
          on: {
            input: _vm.debouncedInputChange,
            focus: _vm.handleFocus,
            blur: _vm.handleBlur
          },
          nativeOn: {
            compositionstart: function($event) {
              return _vm.handleComposition($event)
            },
            compositionend: function($event) {
              return _vm.handleComposition($event)
            }
          },
          model: {
            value: _vm.inputValue,
            callback: function($$v) {
              _vm.inputValue = $$v
            },
            expression: "inputValue"
          }
        },
        [
          _c("template", { slot: "suffix" }, [
            _vm.clearable && _vm.inputHover && _vm.currentLabels.length
              ? _c("i", {
                  key: "1",
                  staticClass:
                    "multi-el-input__icon el-icon-circle-close multi-el-cascader__clearIcon",
                  on: { click: _vm.clearValue }
                })
              : _c("i", {
                  key: "2",
                  staticClass: "multi-el-input__icon el-icon-arrow-down",
                  class: { "is-reverse": _vm.menuVisible }
                })
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                (!_vm.multiple &&
                  _vm.inputValue === "" &&
                  !_vm.isOnComposition) ||
                _vm.multiple,
              expression:
                "(!multiple && inputValue === '' && !isOnComposition) || (multiple)"
            }
          ],
          ref: "tags",
          staticClass: "multi-el-cascader__label",
          class: [
            {
              "multi-el-multicascader__label": _vm.multiple
            }
          ],
          style: { "max-width": _vm.inputWidth - 32 + "px", width: "100%" }
        },
        [
          _vm.multiple
            ? [
                _vm.collapseTags && _vm.currentLabels.length
                  ? _c(
                      "span",
                      [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              closable: !_vm.cascaderDisabled,
                              size: _vm.collapseTagSize,
                              type: "info",
                              "disable-transitions": ""
                            },
                            on: {
                              close: function($event) {
                                _vm.deleteTag($event, 0)
                              }
                            }
                          },
                          [
                            _vm.showAllLevels
                              ? _c(
                                  "span",
                                  { staticClass: "el-select__tags-text" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentLabels[0].join(_vm.separator)
                                      )
                                    )
                                  ]
                                )
                              : _c(
                                  "span",
                                  { staticClass: "el-select__tags-text" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentLabels[0][
                                          _vm.currentLabels[0].length - 1
                                        ]
                                      )
                                    )
                                  ]
                                )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.currentLabels.length > 1
                          ? _c(
                              "el-tag",
                              {
                                attrs: {
                                  closable: false,
                                  size: _vm.collapseTagSize,
                                  type: "info",
                                  "disable-transitions": ""
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "el-select__tags-text" },
                                  [
                                    _vm._v(
                                      "+ " +
                                        _vm._s(_vm.currentLabels.length - 1)
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.collapseTags
                  ? _c(
                      "transition-group",
                      { on: { "after-leave": _vm.resetInputHeight } },
                      _vm._l(_vm.currentLabels, function(item, index) {
                        return _c(
                          "el-tag",
                          {
                            key: item.toString(),
                            staticClass: "el-select__input",
                            attrs: {
                              closable: !_vm.cascaderDisabled,
                              size: _vm.collapseTagSize,
                              type: "info",
                              "disable-transitions": ""
                            },
                            on: {
                              close: function($event) {
                                _vm.deleteTag($event, index)
                              }
                            }
                          },
                          [
                            _vm.showAllLevels
                              ? _c(
                                  "span",
                                  { staticClass: "el-select__tags-text" },
                                  [_vm._v(_vm._s(item.join(_vm.separator)))]
                                )
                              : _c(
                                  "span",
                                  { staticClass: "el-select__tags-text" },
                                  [_vm._v(_vm._s(item[item.length - 1]))]
                                )
                          ]
                        )
                      })
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.filterable && _vm.currentLabels.length
                  ? _c("el-input", {
                      ref: "multiInput",
                      staticClass:
                        "multi-el-multicascader__input multi-el-multicascader__search",
                      class: { "is-focus": _vm.menuVisible },
                      style: {
                        "flex-grow": "1",
                        width: _vm.inputLength / (_vm.inputWidth - 32) + "%",
                        "max-width": _vm.inputWidth - 42 + "px"
                      },
                      attrs: {
                        readonly: _vm.readonly,
                        placeholder: _vm.currentLabels.length
                          ? undefined
                          : _vm.placeholder,
                        "validate-event": false,
                        size: _vm.collapseTagSize,
                        disabled: _vm.cascaderDisabled
                      },
                      on: {
                        input: _vm.debouncedInputChange,
                        focus: _vm.handleFocus,
                        blur: _vm.handleBlur
                      },
                      nativeOn: {
                        compositionstart: function($event) {
                          return _vm.handleComposition($event)
                        },
                        compositionend: function($event) {
                          return _vm.handleComposition($event)
                        }
                      },
                      model: {
                        value: _vm.inputValue,
                        callback: function($$v) {
                          _vm.inputValue = $$v
                        },
                        expression: "inputValue"
                      }
                    })
                  : _vm._e()
              ]
            : [
                _vm.showAllLevels
                  ? [
                      _vm._l(_vm.currentLabels, function(label, index) {
                        return [
                          _vm._v(
                            "\n                    " +
                              _vm._s(label) +
                              "\n                    "
                          ),
                          index < _vm.currentLabels.length - 1
                            ? _c("span", { key: index }, [
                                _vm._v(" " + _vm._s(_vm.separator) + " ")
                              ])
                            : _vm._e()
                        ]
                      })
                    ]
                  : [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.currentLabels[_vm.currentLabels.length - 1]
                          ) +
                          "\n    "
                      )
                    ]
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa610aec", { render: render, staticRenderFns: staticRenderFns })
  }
}